import { global } from "../../constants";

export const data = {

    banner: {
        base: "首页",
        background: global.banner + "ci1.webp",
        title: "企业形象",
        crumb: "企业形象"
    },

    identity : {
        OurMission: {
            title: "我们的使命",
            description: "成为一家在海事领域提供运营、法律和技术服务的前沿公司，帮助我们的商业伙伴实现他们的国际目标。",
            image: global.icons + "our-mission.png",
        },

        OurVision: {
            title: "我们的愿景",
            description: "成为为各类企业，尤其是与国内外海上运输相关的企业，提供咨询、运营和管理服务的标杆；在该领域提供课程和研讨会，并成为主管部门在寻求海事活动最佳实践中的合作伙伴。",
            image: global.icons + "our-vision.png",
        },

        OurValues: {
            title: "我们的价值观",
            description: "我们致力于纪律、遵守国内外标准、遵守我们服务国家的法律、忠诚、勤奋工作以及为我们的商业伙伴追求质量。",
            image: global.icons + "our-values.png",
            values: [
                "纪律",
                "遵守国内外标准",
                "遵守我们服务国家的法律",
                "忠诚",
                "勤奋工作",
                "为我们的商业伙伴追求质量"
            ]
        },
    },
}